/**
 * @fileoverview Zod schemas for OMS source types.
 * @module features/settings/schemas/omsSourceSchema
 */

import { z } from 'zod'

/**
 * OMS (Order Management System) types.
 */
export const OmsTypeSchema = z.enum(['BASELINKER', 'LINNWORKS'])

export type OmsType = z.infer<typeof OmsTypeSchema>

/**
 * OMS source DTO from the backend.
 */
export const OmsSourceSchema = z.object({
  id: z.number(),
  omsType: OmsTypeSchema.nullable(),
  omsSourceId: z.string(),
  omsSourceType: z.string().nullable(),
  omsSourceName: z.string().nullable(),
  omsCategory: z.string().nullable(),
  storeId: z.number().nullable(),
  storeName: z.string().nullable(),
  pendingBackfillCount: z.number(),
  totalOrdersCount: z.number(),
  createdAt: z.string(),
})

export type OmsSource = z.infer<typeof OmsSourceSchema>

export const OmsSourceArraySchema = z.array(OmsSourceSchema)

/**
 * Request to map an OMS source to a store.
 */
export const MapOmsSourceRequestSchema = z.object({
  storeId: z.number(),
})

export type MapOmsSourceRequest = z.infer<typeof MapOmsSourceRequestSchema>

/**
 * Response from mapping an OMS source.
 */
export const MapOmsSourceResponseSchema = z.object({
  omsSource: OmsSourceSchema,
  message: z.string(),
})

export type MapOmsSourceResponse = z.infer<typeof MapOmsSourceResponseSchema>

/**
 * Response from unmapping an OMS source.
 */
export const UnmapOmsSourceResponseSchema = z.object({
  clearedSalesCount: z.number(),
  message: z.string(),
})

export type UnmapOmsSourceResponse = z.infer<typeof UnmapOmsSourceResponseSchema>

/**
 * BaseLinker order source from the API.
 */
export const BaseLinkerOrderSourceSchema = z.object({
  id: z.number(),
  name: z.string(),
  type: z.string(),
  pendingBackfillCount: z.number(),
})

export type BaseLinkerOrderSource = z.infer<typeof BaseLinkerOrderSourceSchema>

export const BaseLinkerOrderSourceArraySchema = z.array(BaseLinkerOrderSourceSchema)

/**
 * Response from syncing OMS sources.
 */
export const SyncOmsSourcesResponseSchema = z.object({
  syncedCount: z.number(),
  sources: OmsSourceArraySchema,
})

export type SyncOmsSourcesResponse = z.infer<typeof SyncOmsSourcesResponseSchema>
